import { useState, useEffect, useCallback } from "react";

import {
  MdMenu,
  MdPerson2,
  MdClose,
} from "react-icons/md";
import "../../../style.min.css";
import Sidenavbar from "./Sidenavbar";
import logo from "../../assets/logo.png";
import { Link, Outlet } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";
import axios from "axios";
const Index = () => {
  
   
  
  
  const { user,language, setLanguage, currency, updateCurrency } = useUserAuth();
   const merchant_id = user.uid;



  const languageHandler = (lang) => {
    setLanguage(lang);
  };

  const langHandler = () => {
    language === "en" ? setLanguage("hi") : setLanguage("en");
  };

  useEffect(() => {
    const myElement = document.getElementById("main-wrapper");
    if (myElement) {
      myElement.classList.remove("show-sidebar");
    }
  }, []);
  const [toggle, setToggle] = useState(false);
  const [windowDimension, setWindowDimension] = useState(window.innerWidth);
  // console.log(windowDimension)
  const [isOpen, setIsOpen] = useState(true);

  const detectSize = () => {
    setWindowDimension(window.innerWidth);
    if (windowDimension < 480) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };
  
  useEffect(() => {
    if (windowDimension < 480) {
      setIsOpen(false);
    }
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [windowDimension]);
  const closeSidebar = () => {
    setToggle(!toggle);
  };
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  
  const [currencies, setCurrencies] = useState([]);
  const options = currencies.map((item) => ({
    value: item.id,
    label: `${item.country_name} - ${item.name} (${item.symbol})`,
  }));
  const selectedOption = options.find((opt) => opt.value === currency?.id);
  const fetchCurrency = useCallback(async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/currency/country`);
      const data = Array.isArray(res.data.data) ? res.data.data : [];
      setCurrencies(data);
    } catch (error) {
      console.error("Error fetching currencies:", error);
    }
  }, []);
  useEffect(() => {
    fetchCurrency();
  }, [fetchCurrency]);

  return (
    <>
      <div
        id="main-wrapper"
        data-layout="vertical"
        data-navbarbg="skin5"
        data-sidebartype={`${isOpen ? "full" : "mini-sidebar"}`}
        data-sidebar-position="absolute"
        data-header-position="absolute"
        data-boxed-layout="full"
        className={`${toggle ? "show-sidebar" : ""}`}
      >
        <header className="topbar" data-navbarbg="skin5">
          <nav className="navbar top-navbar navbar-expand-md ">
            <div className="navbar-header" data-logobg="skin5">
              <Link className="navbar-brand" to="/dashboard/dash_board">
                <span className="logo-text ms-2">
                  <img
                    src={logo}
                    alt="Event Planet"
                    className="light-logo"
                    style={{
                      height: "40px",
                      object: "content",
                    }}
                  />
                </span>
              </Link>
              {/* mobile lang option start */}
              <div onClick={langHandler} className="d-flex d-md-none">
                <div
                  className="lang_box"
                  style={{
                    borderRadius: "50px",
                    background: "var(--main-btn-color)",
                    height: "25px",
                    width: "134px",
                  }}
                >
                  <button
                    className={`btn text-white ${
                      language === "en" ? "bg-success" : null
                    }`}
                    style={{
                      borderRadius: "50px",
                      marginRight: "5px",
                      height: "25px",
                      marginTop: "-40px",
                      fontSize: "11px",
                      lineHeight: "10px",
                    }}
                    onClick={() => languageHandler("en")}
                  >
                    English{" "}
                  </button>
                  <button
                    className={`btn text-white ${
                      language === "hi" ? "bg-success" : null
                    }`}
                    style={{
                      borderRadius: "50px",
                      height: "25px",
                      marginTop: "-40px",
                      fontSize: "11px",
                      lineHeight: "10px",
                    }}
                    onClick={() => languageHandler("hi")}
                  >
                    Hindi
                  </button>
                </div>
              </div>
              {/* mobile lang option end */}
              <a
                className="nav-toggler waves-effect waves-light d-block d-md-none"
                onClick={(e) => setToggle(!toggle)}
              >
                {toggle ? (
                  <MdClose size={24} style={{ color: "#000" }} />
                ) : (
                  <MdMenu size={24} style={{ color: "#000" }} />
                )}
              </a>
            </div>
            <div
              className="navbar-collapse collapse"
              id="navbarSupportedContent"
              data-navbarbg="skin5"
            >
              <ul className="navbar-nav float-start me-auto"></ul>
              <ul className="navbar-nav float-end">

                <li className="nav-item" style={{ cursor: "pointer" }}>
                  <div onClick={langHandler} className="d-flex mt-3">
                    <div
                      className="lang_box"
                      style={{
                        borderRadius: "50px",
                        background: "var(--main-btn-color)",
                        height: "35px",
                        width: "152px",
                      }}
                    >
                      <button
                        className={`btn text-white ${
                          language === "en" ? "bg-success" : null
                        }`}
                        style={{
                          borderRadius: "50px",
                          marginRight: "5px",
                          height: "35px",
                        }}
                        onClick={() => languageHandler("en")}
                      >
                        English{" "}
                      </button>
                      <button
                        className={`btn text-white ${
                          language === "hi" ? "bg-success" : null
                        }`}
                        style={{ borderRadius: "50px", height: "35px" }}
                        onClick={() => languageHandler("hi")}
                      >
                        Hindi
                      </button>
                    </div>
                  </div>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="
                    nav-link
                    dropdown-toggle
                    text-muted
                    waves-effect waves-dark
                    pro-pic
                  "
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <MdPerson2 size={27} />
                  </a>
                  <ul
                    className="dropdown-menu dropdown-menu-end user-dd animated"
                    aria-labelledby="navbarDropdown"
                  >
                    <Link className="dropdown-item" onClick={langHandler}>
                      <i className="mdi mdi-account me-1 ms-1"></i>
                      {language === "en" ? `Change Language` : `भाषा बदले`}
                    </Link>
                    <Link
                      className="dropdown-item"
                      to="/dashboard/book-venue"
                    >
                      <i className="mdi mdi-account me-1 ms-1"></i> Bookings
                    </Link>
                    <Link className="dropdown-item" to="/dashboard/total-reviews">
                      <i className="mdi mdi-account me-1 ms-1"></i> Review
                    </Link>
                    <Link
                      className="dropdown-item"
                      to="/dashboard/packages"
                    >
                      <i className="mdi mdi-account me-1 ms-1"></i>Packages
                    </Link>
                    <Link
                      className="dropdown-item"
                      to="/dashboard/change-password"
                    >
                      <i className="mdi mdi-account me-1 ms-1"></i> Change Password
                    </Link>
                    <div className="dropdown-divider"></div>
                    <Link className="dropdown-item" to="/dashboard/logout">
                      <i className="fa fa-power-off me-1 ms-1"></i> Logout
                    </Link>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </header>

        <Sidenavbar closeSidebar={closeSidebar} />
        {/* <Dashboard /> */}
        {/* <Form /> */}
        <Outlet />
      </div>
      <footer
        className="footer text-center"
        style={{ height: "50px!important", color: "#fff" }}
      >
        All Rights Reserved by Event Planet Technologies India Pvt Ltd. Designed
        and Developed by
        <a href="https://www.eventplanet.in" className="text-white">
          {" "}
          Event Planet
        </a>
      </footer>
    </>
  );
};
export default Index;
